import notificationDecorator from '../modules/Notifications/notificationDecorator';
import { intlShape } from '../components/base/IntlProviderWrapper';
import { normalizeApiError } from './apiError';

export const processFormError = response => {
  const {
    formatMessage,
  } = intlShape;
  if (!response) {
    return window.console.log('The server did not return an error body..');
  }
  const normalized = normalizeApiError(response, {
    defaultMessage: formatMessage({ id: 'app.unknown.error' }),
  });
  if (response instanceof Error) {
    window.console.error(response);
    notificationDecorator({
      title: formatMessage({ id: 'app.error.title' }),
      message: normalized.message,
      isError: true,
    });
  }
  if (response.error && typeof response.error.message !== 'string') {
    window.console.error(response.error);
  }
  return normalized.message;
};
